import React from "react";
import cx from "classnames";
import moment from "moment";
import PropTypes from "prop-types";

import { DropdownTag } from "components/Dropdown";
import Price from "components/Price";
import Translate from "utils/translate";

import DealStatusMessage from "./DealStatusMessage";

import styles from "./DealStatusMessage.css";

const { t } = new Translate("EnquiryStatusMessage");

const ExecutedDealMessage = (props) => {
  const { breakDates, commencementDate, executor, expirationDate, ner, renewalPeriod, spaces } =
    props;

  const start = commencementDate && (
    <div>
      <span dangerouslySetInnerHTML={{ __html: t("commencement") }} />{" "}
      {moment(commencementDate).format("L")}
    </div>
  );
  const breakDate = breakDates && breakDates.length > 0 && (
    <div>
      <span dangerouslySetInnerHTML={{ __html: t("leaseBreak") }} />{" "}
      {moment(breakDates[0]).format("L")}
    </div>
  );

  const expiration = expirationDate && (
    <div>
      <span dangerouslySetInnerHTML={{ __html: t("expiring") }} />{" "}
      {moment(expirationDate).format("L")}
    </div>
  );

  const renewal = renewalPeriod && (
    <div>
      <span dangerouslySetInnerHTML={{ __html: t("renewalPeriod") }} />{" "}
      {renewalPeriod.value > 1 && renewalPeriod.value}{" "}
      {t(`units.${renewalPeriod.period}`, renewalPeriod.value)}
    </div>
  );

  const subtitle = (start || breakDate || expiration) && (
    <div className={styles.subtitle}>
      {start}
      {breakDate}
      {expiration}
      {renewal}
    </div>
  );

  return (
    <DealStatusMessage actor={executor} subtitle={subtitle} isExecuted>
      <>
        {ner && (
          <div className={cx(styles.item, styles.ner)}>
            <strong>{t("ner")}</strong>
            <Price isBold={false} isPeriodBlack={false} price={{ ...ner, period: "monthly" }} />
          </div>
        )}
        {spaces.map((space, index) => (
          <div className={styles.item} key={index}>
            <DropdownTag content={space.name} />
            {!space.firstRefusalRight && (
              <Price isBold={false} isPeriodBlack={false} isUnitBlack={false} price={space.price} />
            )}
            {space.firstRefusalRight && <small>{t("rofr")}</small>}
          </div>
        ))}
      </>
    </DealStatusMessage>
  );
};

ExecutedDealMessage.propTypes = {
  executor: PropTypes.shape({
    fullName: PropTypes.string,
  }),
  commencementDate: PropTypes.string,
  expirationDate: PropTypes.string,
  breakDates: PropTypes.arrayOf(PropTypes.string),
  ner: PropTypes.shape({
    value: PropTypes.number,
    currency: PropTypes.string,
  }),
  renewalPeriod: PropTypes.shape({
    value: PropTypes.number,
    period: PropTypes.string,
  }),
  spaces: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      size: PropTypes.shape({
        value: PropTypes.number,
        unit: PropTypes.string,
      }),
    })
  ),
};

ExecutedDealMessage.defaultProps = {
  spaces: [],
};

export default ExecutedDealMessage;
